export default __webpack_public_path__ + "static/media/pizza@2x.6a6624f0.png";